import { render, staticRenderFns } from "./RevisionFileSelector.vue?vue&type=template&id=2161f6c7&scoped=true"
import script from "./RevisionFileSelector.vue?vue&type=script&lang=js"
export * from "./RevisionFileSelector.vue?vue&type=script&lang=js"
import style0 from "./RevisionFileSelector.vue?vue&type=style&index=0&id=2161f6c7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2161f6c7",
  null
  
)

export default component.exports